import { ArrowRight } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

const ExploreSolutionsAlert = () => {
  const onExploreSolutions = () => window.open('https://codekeeper.co/solutions', '_blank');

  return (
    <Alert className="bg-primary items-center p-6 gap-2 mb-6">
      <div className="col-start-2">
        <AlertTitle className="text-lg mb-1">Explore other solutions</AlertTitle>
        <AlertDescription>
          Application continuity doesn’t stop here! Learn more about our other solutions with the best prices on the
          market.
        </AlertDescription>
      </div>
      <div className="col-start-2 sm:col-start-3">
        <Button variant="outline" onClick={onExploreSolutions}>
          Explore solutions <ArrowRight />
        </Button>
      </div>
    </Alert>
  );
};

export default ExploreSolutionsAlert;
